import {SET_ERROR} from './actions';

const initialState = {
  errorList: [],
}

export const error = (state = initialState, action) => {
  switch (action.type) {

    case SET_ERROR:

      return {
        ...state,
        errorList: [...state.errorList, {error: action.message}]
      };
    default:
      return state;
  }
};


export default error;